//libraries
import { useRef, useEffect, useState } from 'react';
//CSS
import classes from './Timeline.module.css';
//Components
import TimeGrid from './UI/TimeGrid';
import TimeBar from './UI/TimeBar';
import TimelineItem from './TimelineItem';
//Utils
import TransformData from '../tools/transformData';
import useOnScreen from '../tools/useOnScreen';

function Timeline({ klhFetchedData, msFetchedData, typeOfCal }) {
	const [klhItems, setKlhItems] = useState([]);
	const [msItems, setMsItems] = useState([]);

	const timeBarRef = useRef();
	const isVisible = useOnScreen(timeBarRef);

	useEffect(() => {
		scrollIntoview();
	}, [klhItems, msItems]);

	useEffect(() => {
		setKlhItems(TransformData(klhFetchedData));
		setMsItems(TransformData(msFetchedData));
	}, [klhFetchedData, msFetchedData]);

	function scrollIntoview() {
		timeBarRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
	}

	const buttonVisibility = isVisible
		? classes.buttonFadeOut
		: classes.buttonFadeIn;

	const showMS = msItems.length > 0;
	const showKlh = klhItems.length > 0;
	const showOne = showMS !== showKlh;

	const TimeLineStyle = showOne
		? {
				width: '90%',
				marginRight: '20%',
		  }
		: {
				width: '50%',
		  };

	return (
		<div className={classes.timeline}>
			<div className={showOne ? classes.oneTitle : classes.twoTitles}>
				<h1>{typeOfCal}</h1>
			</div>
			<div className={classes.timelineContainer}>
				<TimeGrid />
				<TimeBar timeBarRef={timeBarRef} scrollFunc={scrollIntoview} />
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-evenly',
					}}
				>
					{showKlh && (
						<div style={TimeLineStyle}>
							{klhItems.map((event, idx) => {
								return (
									<TimelineItem
										eventData={event}
										key={`${event.idCode}` + idx}
									/>
								);
							})}
						</div>
					)}
					{showMS && (
						<div style={TimeLineStyle}>
							{msItems.map((event, idx) => {
								return (
									<TimelineItem
										eventData={event}
										key={`${event.idCode}` + idx}
									/>
								);
							})}
						</div>
					)}
				</div>
			</div>
			<button
				className={[classes.centerButton, buttonVisibility].join(' ')}
				onClick={scrollIntoview}
			>
				חזור לנוכחי
			</button>
		</div>
	);
}

export default Timeline;
